module.exports = __webpack_public_path__ + "img/a.52206e2b.jpg";